import { CONSUMER_MODE, CONSUMER_PARTIAL_MODE } from '../../utils/constants';
/**
 * Storage is async if mode is consumer or partial consumer
 */
export function isStorageSync(settings) {
    return [CONSUMER_MODE, CONSUMER_PARTIAL_MODE].indexOf(settings.mode) === -1 ? true : false;
}
